export default __webpack_public_path__ + "static/graphics-c27374743662764880280af0df15974b.png";